<div class="card__face" [class.open]="showDetail">
<div *ngIf="vehicle?.featured === 1" class="featured__ribbon recommended">
    <p class="featured__ribbon__recommended">
        <img alt="" [src]="'images/like.svg' | cdn" />
        {{ 'fe_step2_card_vehicle_featured' | translate }}
    </p>
</div>
<div
    *ngIf="
        discount?.availableUpgrade && discount?.originCategory === vehicle.id
    "
    class="featured__ribbon upgrade"
>
    <p class="featured__ribbon__upgrade">
        {{ 'featured__ribbon__upgrade' | translate }}
    </p>
</div>
<div class="card__container">
    <div
        class="d-flex flex-column flex-md-row justify-content-between flex-wrap flex-xl-nowrap"
        [ngClass]="{ contentInt: international }"
    >
        <div class="d-flex flex-column">
            <h2 class="card__titlte">{{ vehicle.name }}</h2>
            <h3 class="card__subtitlte">{{ vehicle.model }}</h3>
            <div
                class="card__info card__info--list d-flex"
                *ngIf="featureIcons.length"
            >
                <span
                    class="card__info__txt card__info__feature"
                    *ngFor="let feature of featureIcons"
                    [title]="feature.name"
                >
                    <img
                        class="card__info__icon"
                        [src]="feature.img"
                        [alt]="feature.name"
                    />
                    <ng-container
                        *ngIf="
                            feature.quantity !== null &&
                            feature.quantity !== undefined
                        "
                        >{{ feature.quantity }}</ng-container
                    >
                </span>
            </div>
            <div class="card__info d-flex" *ngIf="featureFlags">
                <span class="card__info__txt info1">
                    {{
                        featureFlags?.transmission === 'automatica' ||
                        featureFlags?.transmission === 'Automatic'
                            ? ('fe_step2_card_vehicle_span_transmission_at'
                              | translate)
                            : ('fe_step2_card_vehicle_span_transmission_sd'
                              | translate)
                    }}
                </span>
                <span class="card__info__txt info2">{{
                    featureFlags?.doors
                }}</span>
                <span class="card__info__txt info3">{{
                    featureFlags?.passengers
                }}</span>
                <span
                    class="card__info__txt info4"
                    *ngIf="featureFlags?.air"
                >
                    {{
                        'fe_step2_card_vehicle_span_include_something'
                            | translate
                    }}
                </span>
            </div>
        </div>
        <div class="card__img_wrap d-flex flex-column align-items-center">
            <div
                class="d-flex card__img_cont justify-content-center"
                [ngClass]="{ card__img_int_cont: international }"
            >
                <img alt="img-automovil" class="card__img" [src]="vehicle.img" />
            </div>
            <p
                class="card__inventory"
                *ngIf="!international"
                [class.card__inventory--empty]="!vehicle.showInventory"
            >
                <img
                    alt=""
                    class="card__inventory__icon"
                    [src]="'images/mini-clock.svg' | cdn"
                />
                <span>{{
                    inventoryKey
                        | translate
                        | replace: { units: vehicle.inventory }
                }}</span>
            </p>
        </div>
        <div class="d-flex price__detail_cont flex-column flex-sm-row">
            <div
                class="detail__price d-flex flex-column align-items-center"
                [ngClass]="{ cardInt: international }"
            >
                <p
                    class="offer__price"
                    *ngIf="!international && discountOffice?.percentage as officeDiscountPercentage"
                    [ngClass]="{ sorted: filtered }"
                >
                    <span class="discount__label">-{{ officeDiscountPercentage }}%</span>
                    <span class="offer__price__text">
                        {{
                            savingsDaysKey
                                | translate
                                | replace: getSavingsParams('office')
                        }}
                    </span>
                </p>
                <p
                    class="normal__price"
                    *ngIf="!international; else internationalPrice"
                >
                    <span class="price__amount"
                        >${{
                            vehicle.charges.office?.rentRate
                                | formatNumber: '$' : false
                        }}</span
                    >
                    <span class="currencytxt2">
                        {{
                            vehicle.charges.office?.currency ||
                                vehicle.charges.office?.currency
                        }}<span class="price__per__day"
                            >/{{
                                'fe_details_step3_protection_level_protection_card_middle_pay_day'
                                    | translate
                            }}</span
                        >
                    </span>
                </p>
                <ng-template #internationalPrice>
                    <p class="intRatePrice">
                        $
                        {{
                            vehicle.charges.office?.rentRate
                                | formatNumber: '$' : false
                        }}

                        <span>
                            {{ vehicle.charges.office?.currency }}
                        </span>

                        <span>
                            {{ vehicle.charges.office?.rentType }}
                        </span>
                    </p>
                    <p class="intRateTotal text-uppercase">
                        $
                        {{
                            vehicle.charges.office?.amount
                                | formatNumber: '$' : false
                        }}

                        <span>
                            {{ vehicle.charges.office?.currency }}
                        </span>

                        <span>
                            {{
                                'fe_step2_card_vehicle_p_cost_title_total'
                                    | translate
                            }}
                        </span>
                    </p>
                </ng-template>
                <fe-button
                    class="d-grid btn-next"
                    [btnClass]="'px-0'"
                    [size]="'small'"
                    [loading]="loadingBtnOffice"
                    (onClick)="onclickPrepago(false, vehicle)"
                    [style]="international ? 'tertiary-outline' : 'tertiary-outline'"
                    [ngClass]="{ btninter: international }"
                >
                    <span>
                        {{
                            'fe_step2_card_vehicle_button_select_vehicle_pay_later'
                                | translate
                        }}
                    </span>
                </fe-button>
            </div>
            <div
                class="detail__price2 d-flex flex-column align-items-center"
                *ngIf="vehicle.charges.prepaid?.discount"
            >
                <p
                    class="offer__price"
                    *ngIf="!international && discountPrepaid?.percentage as prepaidDiscountPercentage"
                    [ngClass]="{ sorted: filtered }"
                >
                    <span class="discount__label">-{{ prepaidDiscountPercentage }}%</span>
                    <span class="offer__price__text">
                        {{
                            savingsDaysKey
                                | translate
                                | replace: getSavingsParams('prepaid')
                        }}
                    </span>
                </p>
                <p class="normal__price">
                    <span class="price__amount"
                        >${{
                            vehicle.charges.prepaid?.rentRate
                                | formatNumber: '$' : false
                        }}</span
                    >
                    <span class="currencytxt2">
                        {{ vehicle.charges.prepaid?.currency
                        }}<span class="price__per__day"
                            >/{{
                                'fe_details_step3_protection_level_protection_card_middle_pay_day'
                                    | translate
                            }}</span
                        >
                    </span>
                </p>
                <fe-button
                    class="w-100 d-grid"
                    [size]="'small'"
                    [style]="'tertiary'"
                    [loading]="loadingBtnPrepaid"
                    (onClick)="onclickPrepago(true, vehicle)"
                >
                    {{
                        'fe_step2_card_vehicle_button_select_vehicle_pay_now'
                            | translate
                    }}
                </fe-button>
            </div>
        </div>
    </div>
</div>

<div
    class="card__seemore_details"
    (click)="showDetails()"
    (keydown)="showDetails()"
    role="button"
    tabindex="0"
>
    <span class="material-symbols-outlined arrow-submenumb">
        {{ showDetail ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
    </span>
    {{ 'fe_step2_list_vehicle_button_seemore_vehicle_detail' | translate }}
</div>
</div>
<div
    #accordionDetail
    class="acordion__card__detail d-flex flex-column flex-md-row justify-content-center"
    [class.open]="showDetail"
    [style.max-height.px]="detailMaxHeight"
>
    <div class="col-12 col-sm-4 list__detail__container">
        <h3 class="seemore__info_title text-uppercase">
            {{ 'fe_step2_list_vehicle_h3_card_detail_features' | translate }}
        </h3>
        <ul class="seemore__list">
            <li
                class="seemore__item_list"
                *ngFor="let feature of featureList"
            >
                <img
                    class="seemore__item_icon"
                    *ngIf="feature.img"
                    [src]="feature.img"
                    [alt]="feature.name"
                />
                <i class="check_list_ic" *ngIf="!feature.img"></i>
                <span>{{ feature.name }}</span>
            </li>
            <li class="seemore__item_list" *ngIf="featureFlags?.air">
                <i class="check_list_ic"></i
                ><span>{{
                    'fe_step2_list_vehicle_feature_item_1' | translate
                }}</span>
            </li>
            <li class="seemore__item_list" *ngIf="featureFlags?.radio">
                <i class="check_list_ic"></i
                ><span>{{
                    'fe_step2_list_vehicle_feature_item_2' | translate
                }}</span>
            </li>
            <li
                class="seemore__item_list"
                *ngIf="featureFlags?.transmission"
            >
                <i class="check_list_ic"></i>
                <span *ngIf="currentLang === 'es'"
                    >{{ 'fe_step2_list_vehicle_feature_item_3' | translate }}
                    {{
                        featureFlags?.transmission === 'automatica' ||
                        featureFlags?.transmission === 'Automatic'
                            ? ('fe_step2_card_vehicle_span_transmission_at'
                              | translate)
                            : ('fe_step2_card_vehicle_span_transmission_sd'
                              | translate)
                    }}
                </span>
                <span *ngIf="currentLang === 'en'"
                    >{{
                        featureFlags?.transmission === 'automatica' ||
                        featureFlags?.transmission === 'Automatic'
                            ? ('fe_step2_card_vehicle_span_transmission_at'
                              | translate)
                            : ('fe_step2_card_vehicle_span_transmission_sd'
                              | translate)
                    }}
                    {{ 'fe_step2_list_vehicle_feature_item_3' | translate }}
                </span>
            </li>
        </ul>
    </div>
    <div class="col-12 col-sm-8">
        <div class="d-flex justify-content-end seemore__info_left">
            <span class="seemore__info_headers">{{
                'fe_step2_card_vehicle_span_select_vehicle_text' | translate
            }}</span>
            <span class="seemore__info_headers" *ngIf="vehicle.charges.prepaid">
                {{ 'fe_step2_card_vehicle_h3_cost_title' | translate }}
            </span>
        </div>

        <div class="info__cost__container">
            <div class="rent__cost">
                <h3 class="text-uppercase cost__title">
                    {{
                        'fe_step2_card_vehicle_h3_cost_title_detail_txt'
                            | translate
                    }}
                </h3>
                <div
                    class="d-flex justify-content-end cost__values"
                    *ngIf="!international; else internationalRentRate"
                >
                    <p class="cost__description">
                        ${{
                            vehicle.charges.office?.rentRate
                                | formatNumber: '$' : false
                        }}
                        <span class="text-uppercase">
                            {{ vehicle.charges.office?.currency }}
                        </span>
                    </p>
                    <p class="cost__description" *ngIf="!international">
                        ${{
                            vehicle.charges.prepaid?.rentRate
                                | formatNumber: '$' : false
                        }}
                        <span class="text-uppercase">
                            {{ vehicle.charges.prepaid?.currency }}
                        </span>
                    </p>
                </div>
                <ng-template #internationalRentRate>
                    <div class="d-flex justify-content-end cost__values">
                        <p class="cost__description">
                            $
                            {{
                                vehicle.charges.office?.rentRate
                                    | formatNumber: '$' : false
                            }}
                            <span class="text-uppercase">
                                {{ vehicle.charges.office?.currency }}
                            </span>
                        </p>
                    </div>
                </ng-template>
            </div>
            <div class="tax__cost">
                <div
                    class="d-flex justify-content-between align-items-baseline"
                >
                    <div class="tax__cost__label">
                        <h3 class="text-uppercase cost__title">
                            {{
                                'fe_step2_card_vehicle_h3_cost_title_detail_txt2'
                                    | translate
                            }}
                        </h3>
                        <button
                            class="text-decoration-underline cost__seemore text-start"
                            (click)="modalTaxDetail.fire()"
                        >
                            {{
                                'fe_step2_card_vehicle_button_cost_detail_seemore'
                                    | translate
                            }}
                        </button>
                    </div>
                    <div class="d-flex cost__values">
                        <span class="cost__description">
                            {{
                                'fe_step2_card_vehicle_span_include_something'
                                    | translate
                            }}
                        </span>
                        <span class="cost__description" *ngIf="!international">
                            {{
                                'fe_step2_card_vehicle_span_include_something'
                                    | translate
                            }}
                        </span>
                    </div>
                </div>
            </div>
            <div
                class="total__cost d-flex justify-content-between align-items-baseline"
            >
                <h3 class="cost__title">
                    {{ 'fe_step2_card_vehicle_p_cost_title_total' | translate }}
                </h3>
                <div class="d-flex cost__values">
                    <p
                        class="cost__description"
                        *ngIf="!international; else internationalCost"
                    >
                        ${{
                            vehicle.charges.office?.amount
                                | formatNumber: '$' : false
                        }}
                        <span class="text-uppercase">
                            {{ vehicle.charges.office?.currency }}
                        </span>
                    </p>
                    <p class="cost__description" *ngIf="!international">
                        ${{
                            vehicle.charges.prepaid?.amount
                                | formatNumber: '$' : false
                        }}
                        <span class="text-uppercase">
                            {{ vehicle.charges.prepaid?.currency }}
                        </span>
                    </p>
                    <ng-template #internationalCost>
                        <p
                            class="cost__description"
                            [ngClass]="{ nbordrmg: international }"
                        >
                            ${{
                                vehicle.charges.office?.amount
                                    | formatNumber: '$' : false
                            }}
                            <span class="text-uppercase">
                                {{ vehicle.charges.office?.currency }}
                            </span>
                        </p>
                    </ng-template>
                </div>
            </div>
            <div class="millaje__info">
                <p>
                    {{ 'fe_step2_card_vehicle_p_include_txt' | translate }}
                    <b>
                        {{ 'fe_step2_card_vehicle_p_include_km' | translate }}
                    </b>
                </p>
            </div>
            <div class="millaje__info__txt">
                <p>
                    {{
                        'fe_step2_card_vehicle_p_description_millaje_info'
                            | translate
                    }}
                </p>
            </div>
            <button
                class="paymode_seemore text-decoration-underline"
                *ngIf="!international"
                (click)="modalPayMethod.fire()"
            >
                <i class="seemore__icon"></i>
                {{ 'fe_step2_list_vehicle_button_learn_more' | translate }}
            </button>
        </div>
    </div>
</div>

<swal
    #modalPayMethod
    [showConfirmButton]="false"
    [customClass]="{ popup: 'custom-swal-popup PMethodinfo' }"
    [showCloseButton]="true"
>
    <div *swalPortal="undefined">
        <h2 class="swal2-title">
            {{ 'fe_step2_modal_paymethod_h2_title' | translate }}
        </h2>
        <p>{{ 'fe_step2_modal_paymethod_p_subtitle' | translate }}</p>
        <div class="modal__info">
            <div class="d-flex">
                <i class="discount-icon"></i>
                <p class="modal__subtitle text-start">
                    <b>
                        {{
                            'fe_step2_modal_paymethod_p_subtitle_prepay'
                                | translate
                        }}
                    </b>
                </p>
            </div>
            <p class="modal__description text-start">
                {{
                    'fe_step2_modal_paymethod_p_description_prepay' | translate
                }}
            </p>
            <p class="modal__subtitle text-start">
                <b>{{
                    'fe_step2_modal_paymethod_p_subtitle_office' | translate
                }}</b>
            </p>
            <p class="modal__description text-start">
                {{
                    'fe_step2_modal_paymethod_p_description_office' | translate
                }}
            </p>
        </div>
    </div>
</swal>

<swal
    #modalTaxDetail
    text="This cannot be undone"
    [showConfirmButton]="false"
    [customClass]="{ popup: 'custom-swal-popup taxesInfo' }"
    [showCloseButton]="true"
>
    <div *swalPortal="undefined">
        <h2 class="swal2-title">
            {{ 'fe_step2_card_vehicle_modal_taxes_h2_title' | translate }}
        </h2>
        <div class="modal__info">
            <div class="d-flex justify-content-end info__col__modal">
                <p>
                    <b>{{
                        'fe_step2_card_vehicle_span_select_vehicle_text'
                            | translate
                    }}</b>
                </p>
            </div>
            <div
                class="nartional-layt"
                *ngIf="!international; else internationalTaxes"
            >
                <div
                    class="d-flex justify-content-between info__col__modal bordered"
                >
                    <p class="text-start">
                        <b>{{
                            'fe_step2_card_vehicle_modal_taxes_p_subtitle_taxname'
                                | translate
                        }}</b>
                    </p>
                    <p>
                        <b>
                            $
                            {{
                                getOfficeTaxCharge(vehicle, 0) +
                                    getOfficeTaxCharge(vehicle, 2)
                                    | formatNumber: '$' : false
                            }}
                            <span class="text-uppercase">{{
                                getOfficeTaxCurrency(vehicle, 0)
                            }}</span>
                        </b>
                    </p>
                </div>
                <div class="d-flex justify-content-between info__col__modal">
                    <p class="text-start">
                        {{
                            'fe_step2_card_vehicle_modal_taxes_p_taxname1'
                                | translate
                        }}
                    </p>
                    <p>
                        $
                        {{
                            getOfficeTaxCharge(vehicle, 1)
                                | formatNumber: '$' : false
                        }}
                        <span class="text-uppercase">{{
                            getOfficeTaxCurrency(vehicle, 0)
                        }}</span>
                    </p>
                </div>
                <div class="d-flex justify-content-between info__col__modal">
                    <p class="text-start">
                        {{
                            'fe_step2_card_vehicle_modal_taxes_p_taxname2'
                                | translate
                        }}
                    </p>
                    <p>
                        ${{
                            getOfficeTaxCharge(vehicle, 0)
                                | formatNumber: '$' : false
                        }}
                        <span class="text-uppercase">
                            {{ getOfficeTaxCurrency(vehicle, 0) }}
                        </span>
                    </p>
                </div>
            </div>
            <ng-template #internationalTaxes>
                <div
                    class="d-flex justify-content-between info__col__modal bordered"
                >
                    <p class="text-start">
                        <b>{{
                            'fe_step2_card_vehicle_modal_taxes_p_subtitle_taxname'
                                | translate
                        }}</b>
                    </p>
                    <p>
                        <b
                            >${{ getTotalTaxCharges(vehicle) }}
                            <span class="text-uppercase">{{
                                getOfficeTaxCurrency(vehicle, 0)
                            }}</span></b
                        >
                    </p>
                </div>

                <div
                    class="d-flex justify-content-between info__col__modal"
                    *ngFor="let tax of vehicle.charges.office.taxes"
                >
                    <p class="text-start">
                        {{ tax.tax }}
                    </p>
                    <p>
                        ${{ tax.charge | formatNumber: '$' : false }}
                        <span class="text-uppercase">
                            {{ getOfficeTaxCurrency(vehicle, 0) }}
                        </span>
                    </p>
                </div>
            </ng-template>
        </div>
    </div>
</swal>
